module.exports = __webpack_public_path__ + "img/tlf_dep2.ef1508b6.png";